import FormControl from './FormControl'
import FormGroup from './FormGroup'
import FormValidable from './FormValidable'

export default class FormTemplate extends FormValidable {
  constructor(options = {}) {
    super(options)
    this.form = options.form
    this.name = options.name
    this.label = options.label || null
    this.instances = []
    this.matrix = options.matrix
    this.instancesHistory = 0
    const instanceValues = options.value || [{}]
    instanceValues.forEach((instanceValues) => this.addInstance(instanceValues))
  }

  get value () {
    return this.instances.map((instance) => instance.value)
  }

  validateFromChildren () {
    this.valid = this.valid && this.instances.every((instance) => Object.values(instance.controls).every((control) => control.valid))
  }

  reset () {
    this.instances.forEach((instance) => Object.values(instance).forEach((control) => control.reset()))
  }

  addInstance (instanceValues) {
    const controls = Object.fromEntries(Object.entries(this.matrix).map(([controlName, controlOptions]) => ([
      controlName, 
      new FormControl({ ...controlOptions, value: instanceValues?.[controlName] })
    ]) ))
    this.instances = [ ...this.instances, new FormGroup({ controls, name: this.instancesHistory++, template: this })]
    this.validate()
  }
  
  removeInstance (removingInstance) {
    this.instances = this.instances.filter((instance) => instance !== removingInstance && instance.name !== removingInstance)
    this.validate()
  }
}
